import { css } from '@emotion/css';
import { theme } from 'antd';
import type React from 'react';

const { useToken } = theme;

// Laborgemeinschaft marker: a soft purple tag, independent of the (lab-branded)
// primary color. Purple tokens are opaque and theme-aware (no color-mix).
export const LgBadge: React.FC = () => {
  const { token } = useToken();
  return (
    <span
      className={css`
        display: inline-flex;
        align-items: center;
        vertical-align: middle;
        height: 20px;
        padding: 0 ${token.paddingXS}px;
        border-radius: ${token.borderRadiusSM}px;
        background: ${token.purple1};
        color: ${token.purple6};
        font-size: ${token.fontSizeSM}px;
        font-weight: 600;
        line-height: 1;
        letter-spacing: 0.02em;
      `}
    >
      LG
    </span>
  );
};
